<script setup lang="ts">
import { usePage } from '@inertiajs/vue3';
import { watch } from 'vue';
import { Toaster } from '@/components/ui/sonner';
import { useToast } from '@/composables/useToast';
import { useUserChannel } from '@/composables/useUserChannel';
import 'vue-sonner/style.css';

useUserChannel();
const toast = useToast();
const page = usePage();

watch(
    () => page.props.flash,
    (flash: any) => {
        if (typeof window === 'undefined' || !flash) {
            return;
        }

        if (flash.success) {
            toast.success(flash.success);
        }

        if (flash.error) {
            toast.error(flash.error);
        }

        if (flash.warning) {
            toast.warning(flash.warning);
        }

        if (flash.info) {
            toast.info(flash.info);
        }
    },
    { deep: true },
);
</script>

<template>
    <div class="flex h-screen flex-col overflow-hidden">
        <slot />
        <Toaster />
    </div>
</template>
